import { iso31661 } from "iso-3166";

export const SORTED_COUNTRIES = iso31661.toSorted((countryA, countryB) =>
    countryA.name > countryB.name ? 1 : -1
);

export const PLOTMAP_STATUS = Object.freeze({
    0: { label: "Not delivered" },
    1: { label: "Waiting for validation" },
    2: { label: "Validated" },
    3: { label: "Changes requested" },
});

export const EXPERIMENT_STATUS = Object.freeze({
    "-1": { label: "Not required" },
    0: { label: "Not started" },
    1: { label: "Draft" },
    2: { label: "Completed" },
    3: { label: "Synchronized" },
});
